define('glu/grid/row/rowSubViewWrapper',['require','../../layout','hbs!./rowSubViewWrapper.hbs','../../util'],function(require) {
    'use strict';

    var Layout = require('../../layout'),
        tmpl = require('hbs!./rowSubViewWrapper.hbs'),
        util = require('../../util');

    return Layout.extend({
        tagName: 'tr',
        className: 'grid-subrow hidden',

        regions: {
            subrow: '.js-region-grid-subrow'
        },

        template: tmpl,

        onRender: function() {
            this.showRowSubView();
        },

        showRowSubView: function() {
            this.subRowView = new this.options.RowSubView(util.extend({}, (this.options.rowSubViewOptions || {}), {
                model: this.model
            }));

            this.subrow.show(this.subRowView);
        },

        onSubRowExpanded: function() {
            if (this.subRowView) {
                this.subRowView.triggerMethod('subRowExpanded');
            }
        }
    });
});

